<script lang=ts>
  

let { node, children = undefined } = $props()

const { tag, format } = $state(node);
</script>

<svelte:element this={tag} class="lexical-{tag} lexical-heading {format}">
  {@render children?.()}
</svelte:element>
